// TODO:
// - Refactor this, once we figure out how to cache the menus and menu items. Ideally, we'd run the query in the middleware and call this composable only later.
//
// Composable that fetches and caches menus and menu items,
// builds parent-child relationships, finds the active menu item(s),
// and maps paths for system pages.
export function useCmsMenu(slug: string) {
  const allMenus = useState<Menu[]>('menus', () => [])
  const allMenuItems = useState<ContentMenuItem[]>('menuItems', () => [])

  // console.log(`[useCmsMenu] initial allMenus`, allMenus.value.length)
  // console.log(`[useCmsMenu] initial allMenuItems`, allMenuItems.value.length)

  // WARN [nuxt] Calling useRoute within middleware may lead to misleading results. Instead, use the (to, from)
  // arguments passed to the middleware to access the new and old routes.
  const route = useRoute()
  const { findSystemPageById } = useSystemPages()

  // This needs to be called manually, to prevent race conditions / nuxt context issues.
  // We ran into issues when fetching right here, probably due to useState usage.
  async function fetch() {
    console.log(`[useCmsMenu] fetching menus...`)
    const menus = await fetchMenus()
    const menuItems = await fetchMenuItems({ 'page[size]': 1_000_000 })

    if (menus && menuItems) {
      allMenus.value = menus
      allMenuItems.value = menuItems
    }
  }

  const prependSlash = (path: string) => {
    return path.startsWith('/') ? path : `/${path}`
  }

  // Get the system path, which are defined client side.
  const getPathForItem = (item: ContentMenuItem) => {
    if (item.linkType == 'content_page') {
      return prependSlash(item.path)
    }
    if (item.systemPageId) {
      const systemPage = findSystemPageById(item.systemPageId)
      if (systemPage) {
        return systemPage.path
      }
    }
    // TODO: report error to sentry
    console.error(`No path found for menu item`, item)
    return '/'
  }

  // Map system paths, which are defined client side.
  const mapPaths = (items: ContentMenuItem[]) => {
    return items.map((item) => {
      return { ...item, ...{ path: getPathForItem(item) } }
    })
  }

  const menu = computed(() => {
    return allMenus.value?.find(menu => menu.slug == slug)
  })

  // console.log(`menu`, menu.value)

  const parentMenuItems = computed(() => {
    return mapPaths(
      allMenuItems.value?.filter(
        (item: ContentMenuItem) =>
          item.menuId == menu.value?.id && !item.parentId,
      ),
    )
  })

  const parentExistsInMenu = (parentId: id) => {
    return !!parentMenuItems.value.find(
      parentItem => parentItem.id == parentId,
    )
  }

  // Assuming there aren't two menu items with the same path.
  // Find active childmenu item first
  const activeSubItem = computed(() => {
    return allMenuItems.value?.find(
      item =>
        prependSlash(item.path) == route.path
        && !!item.parentId
        && parentExistsInMenu(item.parentId),
    )
  })

  // console.log(`activeSubItem`, activeSubItem.value)

  const activeMainItem = computed(() => {
    if (activeSubItem.value) {
      // If the current route matches a childmenu item, find the corresponding main menu item
      return parentMenuItems.value?.find(
        mainItem =>
          activeSubItem.value && mainItem.id == activeSubItem.value.parentId,
      )
    }
    else {
      // If the current route matches a main menu item directly
      return parentMenuItems.value?.find(
        item => prependSlash(item.path) == route.path,
      )
    }
  })

  const getChildMenuItemsForMainItem = (
    mainItem: ContentMenuItem | undefined,
  ) => {
    return mapPaths(
      allMenuItems.value?.filter(
        item => mainItem && !!item.parentId && item.parentId == mainItem.id,
      ),
    )
  }

  const activeChildMenuItems = computed(() => {
    return getChildMenuItemsForMainItem(activeMainItem.value)
  })

  return {
    menu,
    parentMenuItems,
    activeChildMenuItems,
    activeMainItem,
    activeSubItem,
    getChildMenuItemsForMainItem,
    fetch,
  }
}
